import { useLocation, useNavigate } from 'react-router-dom';

export const useHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const search = Object.fromEntries(
    new URLSearchParams(location.search).entries(),
  );

  const buildPath = (
    path: string | { pathname: string; search: string },
  ): string => {
    if (typeof path === 'string') return path;
    const searchStr = path.search?.startsWith('?')
      ? path.search
      : `?${path.search}`;
    return `${path.pathname}${searchStr}`;
  };

  const push = (path: string | { pathname: string; search: string }) => {
    navigate(buildPath(path), { replace: false });
  };

  const replace = (path: string | { pathname: string; search: string }) => {
    navigate(buildPath(path), { replace: true });
  };

  const goBack = () => {
    const canGoBack = history?.state?.idx > 0;
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const setQueryParam = (
    param: string,
    value: string,
    pushAndNotReplace: boolean,
  ) => {
    const newSearch = { ...search, [param]: value };
    const searchStr = new URLSearchParams(newSearch).toString();
    const newPath = { pathname: location.pathname, search: searchStr };
    if (pushAndNotReplace) {
      push(newPath);
    } else {
      replace(newPath);
    }
  };

  return { push, goBack, replace, setQueryParam, search };
};
